// Client API of the multi-tenant package "cpackdocs" (country features: documents and operations).
import { apiRequest } from '../api';

export type CountryFeaturesAdmin = {
  country: string; countryName: string;
  uiLanguages: string[]; uiLanguagesOverride: string[]; shippedLanguages: string[]; packLanguages: string[];
  features: Record<string, { value: string | string[]; fromPack: boolean }>;
};
export const cpackdocsApi = {
  /** Admin → Companies: the workspace country's features and the UI language override. */
  adminGet: (): Promise<CountryFeaturesAdmin> => apiRequest('GET', '/country-features/admin'),
  /** [] clears the override (the UI languages follow the country). */
  adminSetLanguages: (uiLanguages: string[]): Promise<CountryFeaturesAdmin> => apiRequest('PUT', '/country-features/admin', { uiLanguages }),
};
